import React, { memo } from 'react';
import { CloseIcon } from '@yme/assets/icons';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { RowNameContainerStyled } from './styled';
export const RowName = memo(({ name, onDismiss }) => (React.createElement(RowNameContainerStyled, null,
    React.createElement(RegularTextLevel4, { color: colorCoreBlack900Base, weight: 500, isUppercase: true }, name),
    onDismiss && (React.createElement(SVGIcon, { type: CloseIcon, size: ICON_SIZE.xs, onClick: onDismiss })))));
RowName.displayName = 'RowName';
